import React from 'react';
import { Clock, MapPin, Sparkles, Mail } from 'lucide-react';

export default function Services() {
  return (
    <section className="bg-white rounded-lg shadow-md p-4 sm:p-6 md:p-8 mb-8" aria-label="Ceník půjčení tumbleru a služeb tromlování" itemScope itemType="https://schema.org/Service">
      <h2 className="text-2xl sm:text-3xl font-bold text-stone-800 mb-4 sm:mb-6">
        Půjčení rotační tromlovačky a služby tromlování v Brně
      </h2>

      <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
        {/* Lease Option */}
        <div className="border-2 border-amber-500 rounded-lg p-4 sm:p-6 bg-amber-50">
          <h3 className="text-xl sm:text-2xl font-bold text-amber-700 mb-2 sm:mb-3">
            Půjčení tromlovačky
          </h3>
          <div className="text-3xl sm:text-4xl font-bold text-amber-600 mb-3 sm:mb-4">
            250 Kč<span className="text-base sm:text-lg font-normal text-stone-600">/týden</span>
          </div>
          <ul className="space-y-2 text-stone-700">
            <li className="flex items-start gap-2">
              <Clock className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
              <span>Půjčení tromlovacího zařízení na týden</span>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
              <span>Osobní vyzvednutí tromlovacího zařízení v Brně</span>
            </li>
          </ul>
          <p className="text-sm text-stone-600 mt-4">
            Ukážeme Vám, jak funguje <strong>hobby tromlovani</strong>, poradíme s materiálem a celým procesem
            <strong> domácího tromlování minerálů</strong>. Je to jednoduché!
          </p>
        </div>

        {/* Tumbling Service */}
        <div className="border-2 border-orange-500 rounded-lg p-4 sm:p-6 bg-orange-50">
          <h3 className="text-xl sm:text-2xl font-bold text-orange-700 mb-2 sm:mb-3">
            Tromlování a leštění za Vás
          </h3>
          <div className="text-2xl sm:text-3xl font-bold text-orange-600 mb-3 sm:mb-4">
            900-1500 Kč<span className="text-base sm:text-lg font-normal text-stone-600">/0.5kg</span>
          </div>
          <ul className="space-y-2 text-stone-700">
            <li className="flex items-start gap-2">
              <Sparkles className="w-5 h-5 text-orange-600 mt-0.5 flex-shrink-0" />
              <span>Kameny a minerály vytromlujeme a vyleštíme v rotačním tumbleru</span>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-5 h-5 text-orange-600 mt-0.5 flex-shrink-0" />
              <span>Kontaktuj nás pro přesnou cenu tromlování</span>
            </li>
          </ul>
          <p className="text-sm text-stone-600 mt-4">
            Hobby <strong>tromlování kamenů</strong>.
            Záleží na množství a typu minerálů. Ozvěte se a domluvíme se!
          </p>
        </div>
      </div>

      <div className="mt-6 p-4 bg-stone-100 rounded-lg">
        <p className="text-stone-700 font-semibold flex items-center gap-2">
          <MapPin className="w-5 h-5 text-stone-600" />
          Zařízení si vyzvednete osobně u nás v Brně - tromlovačku neposíláme, sorry!
        </p>
      </div>
    </section>
  );
}
